<div class="d-flex h-100 flex-column align-items-center justify-content-center">
  <p class="pageTitle">404</p>
  <p class="pageDesc">Oops! Page Not Found </p>
</div>